import React from "react";
import {connect} from "react-redux";
import {Card} from "antd";
import * as types from "../../constants/ActionTypes";
import {fetchCustomer} from "../../actions/callCenterActions";
import {deleteMyDealer} from "../../actions/customerDealerActions";
import {getVin} from "../../selectors/createAppointmentRequest";
import DealerSelection from "./dealer/DealerSelection";
import Constants from "../../services/Constants";
import {FormattedMessage} from "react-intl";
import SAInput from "../common/input/SAInput";

class VinInformation extends React.Component {

  constructor(props) {
    super(props);
    const vehicle = {};
    this.state = {
      vehicle
    };
  }

  getBrand = (vin) => {
    switch (vin) {
      case "WBA"://BMW
      case "X4X"://BMW (AvtoTor (Russia, BMW SKD))
      case "4US"://BMW USA
      case "WBS":// BMW M
        return Constants.BRAND_BMW.value;
      case "WBY":
        return Constants.BRAND_BMW_I.value;
      case "WBW":
      case "WMW":
        return Constants.BRAND_MINI.value;
      default:
        return undefined;
    }
  }

  handleChangeValue = (value) => {
    const {vehicle} = this.state;
    vehicle.vin = value;
    vehicle.brand = this.getBrand(value.slice(0, 3));
    this.setState({vehicle});
    this.props.dispatchSaveGeneralInformation(vehicle);
  };

  handleVinChange = (event) => {
    const formattedVin = event.target.value.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
    this.handleChangeValue(formattedVin);
    // a new vehicle: the dealer has to be chosen again
    this.props.dispatchDeleteMyDealer();
    // complete VIN: prefill customer and license plate
    if (formattedVin.length === 17 && Constants.SUPPORTED_WMIS.includes(formattedVin.slice(0, 3))) {
      this.props.dispatchFetchCustomerInformation(formattedVin);
    }
  };

  validateVin = () => {
    const {vin} = this.props;
    if (!vin) {
      return {message: 'error.not.null'};
    }
    if (vin.length > 2 && !Constants.SUPPORTED_WMIS.includes(vin.slice(0, 3))) {
      return {message: 'error.vin.unsupported'};
    }
    if (vin.length < 17) {
      return {message: 'error.vin.invalid'};
    }
    return null;
  }

  render() {
    const {vin} = this.props;

    return (
      <React.Fragment>
        <Card title={<h3><FormattedMessage id="summary.vin"/></h3>} bordered={false} style={{width: '100%'}}>
          <div className="wrap">
            <div className="content">
              <SAInput
                name={'vin'}
                className={'uppercase'}
                value={vin}
                onChange={this.handleVinChange}
                maxLength={17}
                error={this.validateVin()}
                style={{width: '35%'}}
              />
            </div>
          </div>
        </Card>
        <DealerSelection/>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  vin: getVin(state),
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchCustomerInformation: payload => dispatch(fetchCustomer(payload)),
  dispatchDeleteMyDealer: () => dispatch(deleteMyDealer()),
  dispatchSaveGeneralInformation: (params) => dispatch({type: types.SAVE_GENERAL_INFORMATION, params})
});

export default connect(mapStateToProps, mapDispatchToProps)(VinInformation);
